import { useInfiniteQuery } from '@tanstack/react-query'

import { PriceListImageGalleryParams } from '@/api/_schemas/management'
import { getImageGallery } from '@/api/management'
import { keyStore } from '@/config/key-store'

function useImageGalleryInfinite(
  params: PriceListImageGalleryParams,
  enabled: boolean,
) {
  return useInfiniteQuery({
    queryKey: [...keyStore.priceList.imageGallery.queryKey, params],
    queryFn: async ({ signal, pageParam = 1 }) => {
      const modifiedParams = {
        ...params,
        page: `${pageParam}`,
      }

      return await getImageGallery(modifiedParams, signal)
    },
    initialPageParam: 1,
    getNextPageParam: (data) =>
      data.meta.current_page < data.meta.last_page
        ? data.meta.current_page + 1
        : undefined,
    staleTime: Infinity,
    enabled,
  })
}

export { useImageGalleryInfinite }
